import { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { TrustedPartners } from '../components/TrustedPartners';
import { ImageGenerator } from '../components/ImageGenerator';
import { BenchmarkSection } from '../components/BenchmarkSection';

export function HomePage() {
  useEffect(() => {
    document.title = 'GE-ROOM | AI-Powered Spatial Design';

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'GE-ROOM - Intelligence artificielle pour la conception spatiale. Visualisez et concevez vos espaces plus simplement.');
  }, []);

  return (
    <>
      <Hero />
      <TrustedPartners />
      <ImageGenerator />
      <BenchmarkSection />
    </>
  );
}
